'use client'

import { Navbar } from '@/components/layout/header/navbar'
import { TopBar } from '@/components/layout/header/topbar'
import { TopBarPromotion } from '@/components/layout/header/topbar-promotion'
import { useScrollDirectionNew } from '@/hooks/common/use-scroll-direction-new'
import { useSettingData } from '@/providers/setting-provider'
import { useRef } from 'react'

interface HeaderProps {
  isShowTopBar?: boolean
  isShowNavbar?: boolean
  isShowPromotion?: boolean
  isMobile?: boolean
}

export function Header({
  isShowTopBar = true,
  isShowNavbar = true,
  isShowPromotion = true,
  isMobile,
}: HeaderProps) {
  const { hasScrolled, isScrollingUp } = useScrollDirectionNew(50)
  const headerRef = useRef<HTMLDivElement>(null)
  const homeSetting = useSettingData()

  const getHeaderHeight = () => {
    let height = 0
    if (isShowTopBar) height += 32
    if (isShowNavbar) height += isMobile ? 51 : 68
    if (
      isShowPromotion &&
      !homeSetting?.topbar?.hide &&
      homeSetting?.topbar?.heading
    ) {
      height += 34
    }
    return height
  }

  return (
    <>
      <header
        ref={headerRef}
        className='fixed top-[-1] z-50 w-full lg:top-0'
        aria-label='Site header'
      >
        {isShowTopBar && (
          <TopBar isScrollingDown={hasScrolled && isScrollingUp} />
        )}
        {isShowNavbar && <Navbar isMobile={isMobile} />}
        {isShowPromotion && <TopBarPromotion isScrollingDown={hasScrolled} />}
      </header>
      <div role='presentation' style={{ height: `${getHeaderHeight()}px` }} />
    </>
  )
}
